import { useQuery } from '@tanstack/react-query';
import { fetchLookupCountries } from '@api';

export const useLookupCountries = () => {
  return useQuery({
    queryKey: ['lookupCountries'],
    placeholderData: null,
    queryFn: ({ signal }) =>
      fetchLookupCountries(signal, { ids: [] })
        .then((resp) => {
          const res = {};
          resp.forEach((item) => {
            res[item.id] = item;
          });
          return res;
        })
        .catch(() => null)
  });
};
